import { InputTag } from 'mixs/base/input_mixin';
import { SearchCheckbox } from './checkbox';
export class SelectPhase extends SearchCheckbox {
  
}

riot.mixin('inputs.search.select-phase', SelectPhase as riot.TagMixin)
